module.exports = __webpack_public_path__ + "img/ico1.514b37bc.png";